<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <div
        data-show="true"
        role="document"
        class="modal-dialog modal-dialog modal-xlg">
        <div class="modal-content nlr-busy-modal">
            <div class="modal-header">
                <button
                    type="button"
                    class="close"
                    (click)="dismissModal()"
                    ng-click="$dismiss()"
                    title="Close">
                    <i class="nlrp-icon nlrp-icon-close"></i>
                </button>
                <h3 class="modal-title">Add former tenure</h3>
            </div>
            <div class="modal-body">
                <div class="container-fluid well">
                    @for (formerTenureViewModel of formerTenureViewModelsInit; track formerTenureViewModel; let formerTenureIndex = $index) {
                        <div class="row">
                            <div>
                                <div class="col-xs-3">
                                    <label class="control-label required-input">Parent plan type</label>
                                    <div class="input-group">
                                        <ng-select
                                            class="nlr-ng-select"
                                            [searchable]="false"
                                            [clearable]="false"
                                            [ngClass]="{'has-error': isPlanTypeInValid(formerTenureIndex)}"
                                            [name]="'parentPlanType'+formerTenureIndex"
                                            [id]="'parentPlanType'+formerTenureIndex"
                                            placeholder="Select"
                                            [items]="parentPlanTypes"
                                            bindLabel="name"
                                            bindValue="id"
                                            [ngModel]="formerTenureViewModel.parentPlanType"
                                            (change)="updateSelectedParentType($event, formerTenureIndex)"
                                            required>
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-xs-8">
                                    @if (formerTenureViewModel.parentPlanType && getParentTypeObj(formerTenureIndex).displaySubjectLandDescription) {
                                        <div
                                            ng-if="formerTenureViewModel.parentPlanType && $ctrl.getSelectedParentPlanType($index).displaySubjectLandDescription"
                                            class="row">
                                            <div class="col-xs-4">
                                                <label
                                                    class="control-label"
                                                    [ngClass]="{'required-input': !formerTenureViewModel.subjectLandDescription}"
                                                    >Title</label
                                                >
                                                <div
                                                    class="input-group"
                                                    [ngClass]="{'has-error': (title | formFieldHasError)} || !isTitleValid">
                                                    <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                                    <input
                                                        type="text"
                                                        #title="ngModel"
                                                        class="form-control"
                                                        name="formerTenureTitle"
                                                        placeholder="Enter title"
                                                        [nlrPattern]="titlePattern"
                                                        [(ngModel)]="formerTenureViewModel.title"
                                                        (ngModelChange)="onTitleChange($event, title, formerTenureIndex)"
                                                        ng-model="formerTenureViewModel.title"
                                                        ng-change="$ctrl.onChangeTitle($index)"
                                                        ng-required="!formerTenureViewModel.subjectLandDescription" />
                                                </div>
                                                @if (title | formFieldHasError) {
                                                    <div class="help-block">
                                                        <span>Error!</span>
                                                        <span>Title is invalid, e.g. format should be CL123-1963, EC1234, 1-1, 2-2A </span>
                                                    </div>
                                                }
                                            </div>
                                            <div class="col-xs-8">
                                                <label
                                                    class="control-label"
                                                    [ngClass]="{'required-input': !isTitleValid || !formerTenureViewModel.title}"
                                                    >Subject land description</label
                                                >
                                                <div
                                                    class="input-group"
                                                    [ngClass]="{'has-error': !isTitleValid && !formerTenureViewModel.subjectLandDescription}">
                                                    <span class="input-group-addon corner">
                                                        <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                                                    </span>
                                                    <textarea
                                                        class="form-control"
                                                        name="formerTenureSubjectLandDescription"
                                                        placeholder="Enter subject land description"
                                                        #subjectLandDescription="ngModel"
                                                        rows="2"
                                                        cols="60"
                                                        maxlength="{{subjectLandDescriptionMaxLength}}"
                                                        [(ngModel)]="formerTenureViewModel.subjectLandDescription"
                                                        (ngModelChange)="onSubjectLandDescriptionChange($event, formerTenureIndex)"
                                                        [required]="!formerTenureViewModel.title"></textarea>
                                                </div>
                                                <p>
                                                    <span>{{getSubjectLandDescriptionCharactersRemaining(formerTenureIndex)}}</span>
                                                    <span>characters remaining</span>
                                                </p>
                                            </div>
                                            <div class="col-xs-12">
                                                @if (isTitleInvalid(formerTenureIndex) || isLandDescriptionInvalid(formerTenureIndex)) {
                                                    <div class="help-block">
                                                        <span>Error!</span>
                                                        <span>Title or Subject land description must be entered.</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                    @if (formerTenureViewModel.parentPlanType && !getParentTypeObj(formerTenureIndex).displaySubjectLandDescription) {
                                        <div
                                            ng-if="formerTenureViewModel.parentPlanType && !$ctrl.getSelectedParentPlanType($index).displaySubjectLandDescription"
                                            class="row">
                                            <div class="col-xs-4">
                                                <label
                                                    class="control-label"
                                                    [ngClass]="{'required-input': formerTenureViewModel.parentPlanType}"
                                                    ng-class="{'required-input': formerTenureViewModel.parentPlanType}"
                                                    >Parent plan number</label
                                                >
                                                <div
                                                    class="input-group"
                                                    [ngClass]="{'has-error': isParentPlanNumberInValid(formerTenureIndex)}">
                                                    <span class="input-group-addon">
                                                        <i class="nlrp-icon nlrp-icon-edit"></i>
                                                    </span>
                                                    <input
                                                        type="number"
                                                        name="parentPlanNumber"
                                                        class="form-control"
                                                        [(ngModel)]="formerTenureViewModel.parentPlanNumber"
                                                        (ngModelChange)="onParentPlanNumberChange($event, formerTenureIndex)"
                                                        ng-model="formerTenureViewModel.parentPlanNumber"
                                                        ng-change="$ctrl.onChangeParentPlanNumber($index)"
                                                        ng-disabled="!formerTenureViewModel.parentPlanType"
                                                        ng-required="formerTenureViewModel.parentPlanType" />
                                                </div>
                                            </div>
                                            <div class="col-xs-8">
                                                <label
                                                    class="control-label"
                                                    [ngClass]="{'required-input': formerTenureViewModel.parentPlanType}"
                                                    ng-class="{'required-input': formerTenureViewModel.parentPlanType}"
                                                    >Parent lot/s</label
                                                >
                                                @for (lotRange of formerTenureViewModel.lotRanges; track lotRange; let lotRangeIndex = $index) {
                                                    <div ng-init="lotRangeIndex = $index">
                                                        <div
                                                            class="input-group"
                                                            [ngClass]="{'has-error': isParentLotsInValid(formerTenureIndex, lotRangeIndex)}">
                                                            <span class="input-group-addon">
                                                                <i class="nlrp-icon nlrp-icon-edit"></i>
                                                            </span>
                                                            <input
                                                                type="text"
                                                                name="formerTenure lotRange "
                                                                class="form-control"
                                                                [nlrPattern]="lotPattern"
                                                                [(ngModel)]="lotRange.value"
                                                                (ngModelChange)="onLotRangeChange($event, formerTenureIndex, lotRangeIndex)"
                                                                ng-model="lotRange.value"
                                                                ng-change="$ctrl.onChangeLotRange(formerTenureIndex, lotRangeIndex)"
                                                                ng-disabled="!formerTenureViewModel.parentPlanType"
                                                                ng-required="formerTenureViewModel.parentPlanType" />
                                                            <span
                                                                ng-if="formerTenureViewModel.parentPlanType"
                                                                class="input-group-addon">
                                                                <i
                                                                    class="nlrp-icon nlrp-icon-add"
                                                                    title="Add lot range"
                                                                    (click)="addLotRange(formerTenureIndex, lotRangeIndex)"
                                                                    ng-click="$ctrl.addLotRange(formerTenureIndex, lotRangeIndex)"></i>
                                                            </span>
                                                            <span
                                                                ng-if="formerTenureViewModel.parentPlanType"
                                                                class="input-group-addon">
                                                                <i
                                                                    class="nlrp-icon nlrp-icon-remove"
                                                                    title="Remove lot range"
                                                                    (click)="removeLotRange(formerTenureIndex, lotRangeIndex)"
                                                                    ng-click="$ctrl.removeLotRange(formerTenureIndex, lotRangeIndex)"></i>
                                                            </span>
                                                            @if (formerTenureViewModel.validationErrors) {
                                                                <span class="verify-status">
                                                                    @if (formerTenureViewModel.validationErrors.length < 1) {
                                                                        <i class="nlrp-icon nlrp-icon-verified-passed active"></i>
                                                                    }
                                                                    @if (formerTenureViewModel.validationErrors.length>=1) {
                                                                        <i class="nlrp-icon nlrp-icon-error error"></i>
                                                                    }
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div class="col-xs-1">
                                    <label class="control-label">&nbsp;</label>
                                    <div>
                                        <i
                                            class="nlrp-icon nlrp-icon-add-circle"
                                            (click)="addFormerTenure(formerTenureIndex)"
                                            title="Add former tenure"
                                            tabindex="0"></i>
                                        <i
                                            class="nlrp-icon nlrp-icon-remove-circle"
                                            (click)="removeFormerTenure(formerTenureIndex)"
                                            title="Remove former tenure"
                                            tabindex="0"></i>
                                    </div>
                                </div>
                            </div>
                            @if (formerTenureViewModel.validationErrors && formerTenureViewModel.validationErrors.length) {
                                <div class="col-xs-12">
                                    <div class="help-block">
                                        <span>Error!</span>
                                        <span>{{formerTenureViewModel.validationErrors}}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
            <div class="modal-footer">
                <span class="inline-buttons">
                    <button
                        type="button"
                        class="btn btn-default nlr-btn-sm"
                        id="verifyBtn"
                        title="Verify"
                        (click)="verify()"
                        ng-click="$ctrl.verify(fieldRecordFormerTenureModalForm)"
                        >Verify</button
                    >
                </span>
                <span class="inline-buttons">
                    <p>
                        <button
                            class="btn btn-default nlr-btn-sm"
                            (click)="saveModalData()"
                            [disabled]="!isValid"
                            >Save
                        </button>
                    </p>
                </span>
                <span class="inline-buttons">
                    <p>
                        <button
                            type="button"
                            class="btn btn-warning nlr-btn-sm"
                            title="Cancel"
                            (click)="dismissModal()"
                            >Cancel</button
                        >
                    </p>
                </span>
            </div>
        </div>
    </div>
</div>
